import $ from 'jquery'
import 'tablesorter'

$(function() {
  $('.js_tablesorter').tablesorter();
});
